<template>
  <l-marker :lat-lng="getCoordinates(marker.coordinates)" @click="showModal">
    <l-icon
      :icon-url="iconUrl(marker)"
      :icon-size="iconSize"
      :icon-anchor="[15.375, 37.5]"
      ><img :src="iconUrl(marker)" class="marker-icon" />
      <span v-if="showTooltip" class="marker-icon-text">{{
        markerTitle
      }}</span></l-icon
    >
  </l-marker>
</template>
<script>
import { latLng } from "leaflet";
import {
  LMarker,
  LPopup,
  LTooltip,
  LIcon,
} from "vue2-leaflet";
import { mapGetters } from "vuex";

export default {
  components: {
    LPopup,
    LMarker,
    LTooltip,
    LIcon,
  },
  props: {
    marker: {
      default: () => {},
    },
    iconSize: {
      default: () => [30.75, 37.5],
    },
  },
  data() {
    return {
      withPopup: latLng(47.41322, -1.219482),
      modalId: null,
      type: this.marker.type,
      showTooltip: false,
    };
  },
  mounted() {},
  methods: {
    getCoordinates(coordinates) {
      return latLng(coordinates);
    },
    iconUrl(marker) {
      if (marker.type) {
        if (this.typeInRestAreas) {
          if (Object.keys(this.filters).length) {
            if (
              (this.filters.gasStationTypes &&
                this.filters.gasStationTypes.length) ||
              (this.filters.restAreas &&
                this.filters.restAreas.find(
                  (restArea) => restArea === "gas_station"
                ))
            ) {
              if (
                marker.type === "crodux" ||
                marker.type === "tifon" ||
                marker.type === "energo_invest"
              ) {
                return `/svg/map/markers/${marker.type}.svg`;
              } else {
                return `/svg/map/markers/${marker.type}.svg`;
              }
            } else if (
              this.filters.restAreas &&
              this.filters.restAreas.length > 1
            ) {
              return `/svg/map/markers/restArea.svg`;
            } else if (this.filters.restAreas) {
              let filterName = this.filters.restAreas[0];
              return `/svg/map/markers/restareas/${filterName}.svg`;
            }
          } else {
            if (this.typeGasStation) {
              if (
                marker.type === "crodux" ||
                marker.type === "tifon" ||
                marker.type === "energo_invest"
              ) {
                return `/svg/map/markers/${marker.type}.svg`;
              } else {
                return `/svg/map/markers/${marker.type}.svg`;
              }
            }
            return `/svg/map/markers/restArea.svg`;
          }
        }
        if (marker.type === "tollPlaces") {
          if (
            this.filters &&
            this.filters.tollPlacesType &&
            this.filters.tollPlacesType.find(
              (filter) => filter === "enc_fill"
            ) &&
            marker.enc_fill
          ) {
            return `/svg/map/markers/enc_fill.svg`;
          }
          if (
            this.filters &&
            this.filters.tollPlacesType &&
            this.filters.tollPlacesType.find(
              (filter) => filter === "enc_sale"
            ) &&
            marker.enc_sale
          ) {
            return `/svg/map/markers/enc_sale.svg`;
          }
        }
        return `/svg/map/markers/${marker.type}.svg`;
      } else {
      }
    },
    showModal(e) {
      let response;
      if (this.modal && this.modalId === this.marker.id) {
        response = null;
      } else {
        response = {
          data: this.marker,
          type: this.marker.type,
        };
      }
      this.$store.commit("setModal", response);
    },
  },
  computed: {
    ...mapGetters([
      "markers",
      "filters",
      "modal",
      "restAreas",
      "gasStationTypes",
      "mapZoom",
      "objects",
    ]),
    typeInRestAreas() {
      if (this.type) {
        if (
          this.restAreas.find((restArea) => restArea === this.type) ||
          this.type === "restAreas" ||
          this.type === "searchResult" ||
          this.gasStationTypes.find((gasStation) => gasStation === this.type)
        ) {
          return true;
        }
      }
      return false;
    },
    typeGasStation() {
      if (this.type) {
        if (
          this.gasStationTypes.find((gasStation) => gasStation === this.type)
        ) {
          return true;
        }
      }
      return false;
    },
    markerTitle() {
      if (this.typeInObjects) {
        if (this.marker.translation) {
          let activeTranslation = this.marker.translation.find(
            (trans) => trans.locale === window.default_locale
          );
          return activeTranslation.title;
        } else if (this.marker.translations) {
          let activeTranslation = this.marker.translations.find(
            (trans) => trans.locale === window.default_locale
          );
          return activeTranslation.title;
        }
      } else {
        return this.marker.name;
      }
    },
    typeInObjects() {
      if (this.type) {
        if (this.objects.find((object) => object === this.type)) {
          return true;
        }
      }
      return false;
    },
  },
  watch: {
    modal() {
      if (this.modal && this.modal.data) {
        this.modalId = this.modal.data.id;
      } else {
        this.modalId = null;
      }
    },
    mapZoom(newVal) {
      this.showTooltip = newVal > 9;
    },
  },
};
</script>
